// services/contactService.js

import { db } from "./firebase";

import {
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";

export const saveLead = async (formData) => {
  return await addDoc(
    collection(db, "website_leads"),
    {
      ...formData,

      status: "new",

      source: "codeintelailabs",

      createdAt: serverTimestamp(),
    }
  );
};